module.exports = __webpack_public_path__ + "static/media/icon-heart.6056865c.svg";